import React from 'react';
import s from './RadioOption.scss';
import cx from 'classnames';
import {IGalleryGlobalProps} from '../../galleryGlobalStrategy';
import {IProvidedTranslationProps} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../globalPropsContext';

export interface FilterOptionProps extends IGalleryGlobalProps {
  id: string;
  label: string;
  onChange: Function;
  selected: boolean;
}

class RadioOptionComp extends React.PureComponent<FilterOptionProps & IProvidedTranslationProps> {
  private focusedByMouse: boolean = false;
  public state = {
    focusVisible: false,
  };

  private isFocusRing(): boolean {
    const {
      globals: {accessibilityEnabled},
    } = this.props;
    return accessibilityEnabled && this.state.focusVisible;
  }

  public render() {
    const {id, label, onChange, selected} = this.props;
    const classNames = cx(
      'wixSdkShowFocusOnSibling',
      s.label,
      {[s.selected]: selected},
      {[s.focusRing]: this.isFocusRing()}
    );

    return (
      // eslint-disable-next-line
      <label
        onClick={this.handleClick}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        data-hook="label"
        className={classNames}>
        <input
          data-hook="radio-option-input"
          type="radio"
          value={id}
          checked={selected}
          onChange={(e) => onChange(e)}
          className={s.inputSrOnly}
          tabIndex={selected ? 0 : -1}
        />
        {label}
      </label>
    );
  }

  private readonly handleClick = () => {
    this.focusedByMouse = true;
  };

  private readonly onFocus = () => {
    if (!this.focusedByMouse) {
      this.setState({focusVisible: true});
    }
  };

  private readonly onBlur = () => {
    this.setState({focusVisible: false});
    this.focusedByMouse = false;
  };
}

export const RadioOption = withGlobals(RadioOptionComp);
